module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "school-data"
  }, [_c('div', {
    staticClass: "school-data__header"
  }, [_c('div', {
    staticClass: "school-data__header__left"
  }, [_c('h1', [_vm._v("Fraværets varighed")]), _vm._v(" "), _c('changeSchoolYear', {
    staticClass: "marg-1-right",
    attrs: {
      "white-theme": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "school-data__header__right"
  }, [(!_vm.isDatesPristine) ? _c('p', {
    staticClass: "d-link",
    on: {
      "click": _vm.resetDates
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), _c('Datepickerrange', {
    attrs: {
      "startdate": _vm.startDate,
      "enddate": _vm.endDate
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": _vm.setEndDate
    }
  })], 1)]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loader-container"
  }, [_c('Loader'), _vm._v(" "), _c('h4', [_vm._v("Snup en kop kaffe, det kan tage et par minutter")])], 1) : [_c('p', {
    staticClass: "text-explainer"
  }, [_vm._v("\n      Et fraværsforløb er sammenhængende hverdage med fravær for den samme medarbejder og den samme årsag.\n      Weekender afbryder ikke et forløb. Tallene viser antal forløb fordelt på, hvor mange dage de varede.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "filters"
  }, [_c('DoFiltersFilter', {
    attrs: {
      "title": "Årsager",
      "tags": _vm.absenceReasons,
      "selectedTags": _vm.selectedReasons
    },
    on: {
      "select": _vm.toggleReason,
      "clear": function($event) {
        _vm.selectedReasons = []
      }
    }
  })], 1), _vm._v(" "), _c('table', {
    staticClass: "d-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Årsag")]), _vm._v(" "), _vm._l((_vm.buckets), function(bucket) {
    return _c('th', {
      key: bucket.id
    }, [_vm._v(_vm._s(bucket.title))])
  }), _vm._v(" "), _c('th', [_vm._v("Forløb i alt")]), _vm._v(" "), _c('th', [_vm._v("Fraværsdage i alt")]), _vm._v(" "), _c('th', [_vm._v("Personer")])], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.rows), function(row) {
    return _c('tr', {
      key: row.name,
      class: {
        'd-table__total': row.isTotal
      }
    }, [_c('td', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _vm._l((_vm.buckets), function(bucket) {
      return _c('td', {
        key: bucket.id
      }, [_vm._v("\n          " + _vm._s(row.buckets[bucket.id]) + "\n          "), (row.buckets[bucket.id]) ? _c('span', {
        staticClass: "d-table__share"
      }, [_vm._v("(" + _vm._s(_vm.formatPercent(row.buckets[bucket.id], row.periods)) + ")")]) : _vm._e()])
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.periods))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.days))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.persons))])], 2)
  }), _vm._v(" "), (_vm.rows.length < 2) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": _vm.buckets.length + 4
    }
  }, [_vm._v("Intet fravær i perioden")])]) : _vm._e()], 2)])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b5a02d0e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SchoolData/SchoolDataAbsenceDuration.vue
// module id = 2098
// module chunks = 1